// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page__Layout-module--hy6ZS {
    background: var(--color-surface-base);
    color: var(--color-text-primary);
    text-align: left;
}

.page__Layout-module--hy6ZS a.ant-btn {
    text-decoration: none;
}

.page__Layout-module--hy6ZS .ant-btn {
    text-transform: none;
}

.page__Layout-module--hy6ZS .ant-btn-variant-outlined {
    background: var(--home-color-orange-tint);
    border-color: var(--home-color-orange-tint);
    color: var(--color-text-primary);
}

.page__Layout-module--hy6ZS.page__Layout-module--hy6ZS .ant-btn-variant-outlined:not(:disabled):hover {
    background: var(--home-color-orange-tint-hover);
    border-color: var(--home-color-orange-tint-hover);
    color: var(--color-text-primary);
    outline: none;
}

.page__Layout-module--hy6ZS.page__Layout-module--hy6ZS .ant-btn-variant-outlined:not(:disabled):active {
    background: var(--home-color-orange-tint-active);
    border-color: var(--home-color-orange-tint-active);
    color: var(--color-text-primary);
}

.skipLink__Layout-module--mUT5_ {
    position: absolute;
    left: -9999px;
    top: 0;
    z-index: 100;
    padding: var(--space-xs) var(--space-sm);
    background: var(--home-color-orange);
    color: var(--color-text-primary);
    border-bottom-right-radius: var(--home-radius-lg);
}

.skipLink__Layout-module--mUT5_:focus {
    left: 0;
}

.header__Layout-module--RUlFm {
    position: sticky;
    top: 0;
    z-index: 50;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: var(--space-sm);
    padding: var(--space-xs) var(--space-md);
    background: color-mix(in srgb, var(--color-surface-base) 82%, transparent);
    backdrop-filter: blur(14px);
    -webkit-backdrop-filter: blur(14px);
    border-bottom: 1px solid var(--color-border-default);
}

.logoLockup__Layout-module--Tk3wi {
    display: flex;
    align-items: center;
    gap: var(--space-xs);
    flex-shrink: 0;
}

.logos__Layout-module--Q5ntr {
    display: flex;
    align-items: center;
    gap: var(--space-sm);
}

/*
 * The supplied wordmark is white (for dark backgrounds); the filter renders it in black, the Cambridge
 * colour for light backgrounds. Cambridge's minimum on-screen width is 150px.
 */
.cambridgeLogo__Layout-module--bEwgJ {
    display: block;
    width: 150px;
    height: auto;
    filter: brightness(0);
}

.hotmathsLogo__Layout-module--kGDcf {
    display: block;
    height: 24px;
    width: auto;
}

/*
 * Slightly larger in the header, beside the Cambridge logo. The flame reaches below the lettering, so
 * centring the boxes leaves the "HOTmaths" lettering 3px lower than "CAMBRIDGE"; the nudge lines the two
 * up optically.
 */
.logos__Layout-module--Q5ntr .hotmathsLogo__Layout-module--kGDcf {
    height: 30px;
    transform: translateY(-3px);
}

.nav__Layout-module--gbs6R.nav__Layout-module--gbs6R ul {
    display: flex;
    flex-wrap: wrap;
    gap: var(--space-sm);
    margin: 0;
    padding: 0;
    list-style: none;
}

.nav__Layout-module--gbs6R.nav__Layout-module--gbs6R li {
    margin: 0;
}

.nav__Layout-module--gbs6R a {
    font-size: 14px;
    font-weight: 600;
    text-decoration: none;
    color: var(--color-text-secondary);
}

.nav__Layout-module--gbs6R a:focus-visible {
    outline: 2px solid var(--color-focus-outline);
    outline-offset: var(--focus-outline-offset);
    border-radius: var(--radius-sm);
}

.actions__Layout-module--BtCfu {
    display: flex;
    align-items: center;
    gap: var(--space-sm);
    flex-shrink: 0;
    margin-left: auto;
}

.footer__Layout-module--Nkagy {
    background: var(--color-surface-inverse);
    color: var(--color-neutral-200);
    padding: var(--space-lg) var(--space-md);
}

.footerInner__Layout-module--B1HpA {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: var(--space-md);
}

.footerInner__Layout-module--B1HpA p {
    margin: 0;
    font-size: 14px;
}

.footerLogos__Layout-module--Uz2SL {
    display: flex;
    align-items: center;
    gap: var(--space-xs);
}
`, "",{"version":3,"sources":["webpack://./src/main/ui/home/components/Layout.module.css"],"names":[],"mappings":"AAAA;IACI,qCAAqC;IACrC,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,yCAAyC;IACzC,2CAA2C;IAC3C,gCAAgC;AACpC;;AAEA;IACI,+CAA+C;IAC/C,iDAAiD;IACjD,gCAAgC;IAChC,aAAa;AACjB;;AAEA;IACI,gDAAgD;IAChD,kDAAkD;IAClD,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,MAAM;IACN,YAAY;IACZ,wCAAwC;IACxC,oCAAoC;IACpC,gCAAgC;IAChC,iDAAiD;AACrD;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,WAAW;IACX,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,oBAAoB;IACpB,wCAAwC;IACxC,0EAA0E;IAC1E,2BAA2B;IAC3B,mCAAmC;IACnC,oDAAoD;AACxD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;;;EAGE;AACF;IACI,cAAc;IACd,YAAY;IACZ,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,WAAW;AACf;;AAEA;;;;EAIE;AACF;IACI,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,oBAAoB;IACpB,SAAS;IACT,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,kCAAkC;AACtC;;AAEA;IACI,6CAA6C;IAC7C,2CAA2C;IAC3C,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,wCAAwC;IACxC,+BAA+B;IAC/B,wCAAwC;AAC5C;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,8BAA8B;IAC9B,oBAAoB;AACxB;;AAEA;IACI,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,oBAAoB;AACxB","sourcesContent":[".page {\n    background: var(--color-surface-base);\n    color: var(--color-text-primary);\n    text-align: left;\n}\n\n.page :global(a.ant-btn) {\n    text-decoration: none;\n}\n\n.page :global(.ant-btn) {\n    text-transform: none;\n}\n\n.page :global(.ant-btn-variant-outlined) {\n    background: var(--home-color-orange-tint);\n    border-color: var(--home-color-orange-tint);\n    color: var(--color-text-primary);\n}\n\n.page.page :global(.ant-btn-variant-outlined:not(:disabled):hover) {\n    background: var(--home-color-orange-tint-hover);\n    border-color: var(--home-color-orange-tint-hover);\n    color: var(--color-text-primary);\n    outline: none;\n}\n\n.page.page :global(.ant-btn-variant-outlined:not(:disabled):active) {\n    background: var(--home-color-orange-tint-active);\n    border-color: var(--home-color-orange-tint-active);\n    color: var(--color-text-primary);\n}\n\n.skipLink {\n    position: absolute;\n    left: -9999px;\n    top: 0;\n    z-index: 100;\n    padding: var(--space-xs) var(--space-sm);\n    background: var(--home-color-orange);\n    color: var(--color-text-primary);\n    border-bottom-right-radius: var(--home-radius-lg);\n}\n\n.skipLink:focus {\n    left: 0;\n}\n\n.header {\n    position: sticky;\n    top: 0;\n    z-index: 50;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: var(--space-sm);\n    padding: var(--space-xs) var(--space-md);\n    background: color-mix(in srgb, var(--color-surface-base) 82%, transparent);\n    backdrop-filter: blur(14px);\n    -webkit-backdrop-filter: blur(14px);\n    border-bottom: 1px solid var(--color-border-default);\n}\n\n.logoLockup {\n    display: flex;\n    align-items: center;\n    gap: var(--space-xs);\n    flex-shrink: 0;\n}\n\n.logos {\n    display: flex;\n    align-items: center;\n    gap: var(--space-sm);\n}\n\n/*\n * The supplied wordmark is white (for dark backgrounds); the filter renders it in black, the Cambridge\n * colour for light backgrounds. Cambridge's minimum on-screen width is 150px.\n */\n.cambridgeLogo {\n    display: block;\n    width: 150px;\n    height: auto;\n    filter: brightness(0);\n}\n\n.hotmathsLogo {\n    display: block;\n    height: 24px;\n    width: auto;\n}\n\n/*\n * Slightly larger in the header, beside the Cambridge logo. The flame reaches below the lettering, so\n * centring the boxes leaves the \"HOTmaths\" lettering 3px lower than \"CAMBRIDGE\"; the nudge lines the two\n * up optically.\n */\n.logos .hotmathsLogo {\n    height: 30px;\n    transform: translateY(-3px);\n}\n\n.nav.nav ul {\n    display: flex;\n    flex-wrap: wrap;\n    gap: var(--space-sm);\n    margin: 0;\n    padding: 0;\n    list-style: none;\n}\n\n.nav.nav li {\n    margin: 0;\n}\n\n.nav a {\n    font-size: 14px;\n    font-weight: 600;\n    text-decoration: none;\n    color: var(--color-text-secondary);\n}\n\n.nav a:focus-visible {\n    outline: 2px solid var(--color-focus-outline);\n    outline-offset: var(--focus-outline-offset);\n    border-radius: var(--radius-sm);\n}\n\n.actions {\n    display: flex;\n    align-items: center;\n    gap: var(--space-sm);\n    flex-shrink: 0;\n    margin-left: auto;\n}\n\n.footer {\n    background: var(--color-surface-inverse);\n    color: var(--color-neutral-200);\n    padding: var(--space-lg) var(--space-md);\n}\n\n.footerInner {\n    max-width: 1200px;\n    margin: 0 auto;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n    gap: var(--space-md);\n}\n\n.footerInner p {\n    margin: 0;\n    font-size: 14px;\n}\n\n.footerLogos {\n    display: flex;\n    align-items: center;\n    gap: var(--space-xs);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `page__Layout-module--hy6ZS`,
	"skipLink": `skipLink__Layout-module--mUT5_`,
	"header": `header__Layout-module--RUlFm`,
	"logoLockup": `logoLockup__Layout-module--Tk3wi`,
	"logos": `logos__Layout-module--Q5ntr`,
	"cambridgeLogo": `cambridgeLogo__Layout-module--bEwgJ`,
	"hotmathsLogo": `hotmathsLogo__Layout-module--kGDcf`,
	"nav": `nav__Layout-module--gbs6R`,
	"actions": `actions__Layout-module--BtCfu`,
	"footer": `footer__Layout-module--Nkagy`,
	"footerInner": `footerInner__Layout-module--B1HpA`,
	"footerLogos": `footerLogos__Layout-module--Uz2SL`
};
export default ___CSS_LOADER_EXPORT___;
